import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
function useBuilderDrawerState() {
  const $ = _c(4);
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQuery = window.matchMedia("(min-width: 1024px)");
      const listener = event => {
        if (event.matches) {
          setOpen(false);
        }
      };
      mediaQuery.addEventListener("change", listener);
      return () => {
        mediaQuery.removeEventListener("change", listener);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== open) {
    t2 = [open, setOpen];
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export { useBuilderDrawerState };